import { createFileRoute } from '@tanstack/react-router'
import { ComplianceRulesPage } from '../../../components/ComplianceRulesPage'

export const Route = createFileRoute('/$org/compliance-rules/')({
  component: ComplianceRules,
  validateSearch: (search: Record<string, unknown>) => ({
    control_code: (search.control_code as string) || undefined,
  }),
})

function ComplianceRules() {
  return <ComplianceRulesPage />
}
